import { render, staticRenderFns } from "./angle-controls.vue?vue&type=template&id=7952601a"
import script from "./angle-controls.vue?vue&type=script&lang=js"
export * from "./angle-controls.vue?vue&type=script&lang=js"
import style0 from "./angle-controls.vue?vue&type=style&index=0&id=7952601a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports